module.exports = __webpack_public_path__ + "img/IMG-20200316-WA0033.7390d182.jpg";